import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackRemoveFolder } from './tracking';
import { closeModalRemove } from '../../../actions/folders/actions';
import { ModalRemove } from '../../../components/FolderHeader/menu/ModalRemove';
import { selectResults, selectIsSearcherOrSub } from '../../../selectors';
import { selectSelectedFolder, selectSelectedId } from '../../../selectors/folders';
import { deleteFolder } from '../../../thunk/favorites/deleteFolders';

export function ModalRemoveContainer() {
  const dispatch = useDispatch();
  const selectedFolderId = useSelector(selectSelectedId);
  const folder = useSelector(selectSelectedFolder);
  const { favoriteEntities } = useSelector(selectResults);
  const isSearcherOrSub = useSelector(selectIsSearcherOrSub);

  const handleConfirm = () => {
    dispatch(closeModalRemove());

    if (!selectedFolderId || !folder) {
      return;
    }

    trackRemoveFolder(favoriteEntities);
    dispatch(deleteFolder(selectedFolderId));
  };

  return (
    <ModalRemove
      isSearcherOrSub={isSearcherOrSub}
      isVisible={true}
      onConfirm={handleConfirm}
      onCancel={() => dispatch(closeModalRemove())}
    />
  );
}
